// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".styles-module__HiddenInput___2SDIe{height:0;opacity:0;position:absolute;width:0}", "",{"version":3,"sources":["/tmp/build_9ddd188e/app/javascript/src/components/buttons/SegmentedButton/styles.module.scss"],"names":[],"mappings":"AAGA,oCACE,QAAA,CACA,SAAA,CACA,iBAAA,CACA,OAAA","file":"styles.module.scss","sourcesContent":["@import \"../../../styles/mixins/index.scss\";\n@import \"../../../styles/variables/index.scss\";\n\n.HiddenInput {\n  height: 0;\n  opacity: 0;\n  position: absolute;\n  width: 0;\n}\n"]}]);
// Exports
exports.locals = {
	"HiddenInput": "styles-module__HiddenInput___2SDIe"
};
module.exports = exports;
